import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import AdminDashboard from "./screens/admin/AdminDashboard"
import { useContext, useEffect, useState } from "react"
import AdminNavs from "./components/admin/AdminNavs"
import Header from "./components/Header"
// import AdminSettings from "./screens/admin/AdminSettings"
import AddProduct from "./screens/admin/AddProduct"
import { AppContext } from "./context/AppContext"
import Users from "./screens/admin/Users"
import AddSalesRep from "./screens/admin/AddSalesRep"
import Sales from "./screens/admin/Sales"
import Settings from "./screens/Settings"
import Inventory from "./screens/admin/Inventory"

const Admin = () => {

    const { loggedIn, setLoggedIn } = useContext(AppContext)

    const location = useLocation()
    const Navigate = useNavigate()

    const [headerTitle, setHeaderTitle] = useState('')
    const [expandedNav, setExpandedNav] = useState(false)

    const handleTitleChange = () => {
        switch (location.pathname) {
            case '/admin/dashboard':
                setHeaderTitle('Dashboard')
                break;

            case '/admin/sales':
                setHeaderTitle('Sales')
                break;

            case '/admin/add_product':
                setHeaderTitle('Add Product')
                break;

            case '/admin/inventory':
                setHeaderTitle('Inventory')
                break;

            case '/admin/add_sales_rep':
                setHeaderTitle('Add Sales Rep')
                break;

            case '/admin/users':
                setHeaderTitle('Users')
                break;

            case '/admin/settings':
                setHeaderTitle('Settings')
                break;

            default:
                if (location.pathname.includes('/admin/inventory/detail/')) {
                    setHeaderTitle('Inventory > Detail')
                } else if (location.pathname.includes('/admin/inventory/edit/')) {
                    setHeaderTitle('Inventory > Edit')
                } else {
                    setHeaderTitle('Admin')
                }
                break;
        }
    }

    useEffect(() => {
        if (!loggedIn) {
            Navigate('/login')
        }
    }, [loggedIn, Navigate])

    useEffect(() => {
        handleTitleChange()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    return (
        <div className=" w-full h-screen md:flex relative">
            <AdminNavs expandedNav={expandedNav} setExpandedNav={setExpandedNav} />

            <div onClick={() => setExpandedNav(false)} className={`${expandedNav ? " block" : " hidden"} md:hidden fixed w-screen h-screen z-10`}></div>

            <div className=" h-full overflow-y-auto overflow-x-hidden md:flex-1 scrollbar relative">
                <Header setExpandedNav={setExpandedNav} title={headerTitle} setLoggedIn={setLoggedIn} />
                <Routes>
                    <Route element={<AdminDashboard />} path="/dashboard" />
                    <Route element={<Sales />} path="/sales" />
                    <Route element={<AddProduct />} path="/add_product" />
                    <Route element={<Inventory />} path="/inventory/*" />
                    <Route element={<AddSalesRep />} path="/add_sales_rep" />
                    <Route element={<Users />} path="/users" />
                    {/* <Route element={<AdminSettings />} path="/settings" /> */}
                    <Route element={<Settings userType={'Admin'} />} path="/settings" />
                </Routes>
            </div>
        </div>
    )
}

export default Admin